export default "__VITE_ASSET__8825a1f6__"